export default "__VITE_ASSET__6ee18627__"